<template>
  <div>
    <EbHeading level="h1" class="eb-page-heading eb-upper-title">Réinitialisation du mot de passe</EbHeading>
    
    <router-link :to="{name:'login'}" class="back-link"><font-awesome-icon :icon="['fas', 'chevron-left']" class="mr-5" /> Retour au formulaire de connexion</router-link>
    
    <EbBanner :isActive="tokenUnknown" type="error" title="Le token n’existe pas ou plus" class="mt-24">Veuillez vérifier ou faire une nouvelle demande de mot de passe oublié.</EbBanner>
    
    <div v-if="!tokenUnknown">
      <div v-if="page==='validated'">
        <EbBanner type="success" class="mt-24">Le mot de passe a bien été modifié, vous pouvez maintenant vous connecter.</EbBanner>
        <EbLinkButton :to="{name: 'dispofuture'}" class="medium primary expanded site-color">Me connecter</EbLinkButton>
      </div>
      <form v-else action="#" @submit.prevent="setNewPassword()">
        <EbPassword v-model="newPassword" required label="Nouveau mot de passe" needCondition width="expand"></EbPassword>
        <EbButton type="submit" centered="centered" expanded="expanded" site-color="site-color">Enregistrer</EbButton>
      </form>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  props: {
    token: String
  },
  data() {
    return {
      newPassword: null,
      confirmNewPassword: null,
      passwordError: false,
      page: null,
      tokenUnknown: false
    }
  },
  mounted() {
    if(this.token) {
      this.checkToken()
    }
  },
  methods: {
    setNewPassword: async function() {
      await this.$http.put('authentification/motDePasseOublie/change', {
        newPassword: this.newPassword,
        token: this.token
      })
      .then(resp => {
        this.page='validated'
      })
      .catch(error => {
        if(error.response.status === 404) {
          this.tokenUnknown = true
        }
      })
    },
    checkToken: async function() {
      await this.$http.get('authentification/checkToken', {
        params: {
          token: this.token
        }
      })
      .catch(error => {
        this.tokenUnknown = true
      })
    }
  }
}
</script>